import React from 'react';
import './Topbar.css';

const Topbar = () => {
  return (
    <div className="topbar-futuristic">
      <div className="topbar-gradient"></div>
      <div className="container-fluid">
        <div className="row align-items-center py-2">
          <div className="col-md-6">
            <div className="d-flex align-items-center gap-3">
              <div className="pulse-dot"></div>
              <small className="text-white fw-light">Global Logistics Network • Real-time Tracking</small>
            </div>
          </div>
          <div className="col-md-6 text-end">
            <small className="text-white-50">24/7 Support Available</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
